const initialConfigState = {
  isShowLoading: false,
};

 const ConfigReducer = (state = initialConfigState, action) => {
  switch (action.type) {
    case "showLoading": {
      return { ...state, isShowLoading: true };
    }
    case "hideLoading": {
      return { ...state, isShowLoading: false };
    }

    default:
      return state;
  }
};
export default ConfigReducer;